module.exports = __webpack_public_path__ + "img/mir-logo.2be6bd9f.svg";